"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanPopovers = void 0;
var cleanPopovers = function () {
    var ps = Array.from(document.querySelectorAll('.Popover'));
    ps.forEach(function (e) { return e.remove(); });
};
exports.cleanPopovers = cleanPopovers;
//# sourceMappingURL=index.js.map